import {all, call, put, takeLatest, takeEvery, select} from "redux-saga/effects";
import {getErrorMessage} from "utils/sagasErrorHandler";
import {
    getBrandTrackedDomains,
    getBrandTrackedDomainsByBrandCode,
    getBrandTrackedDomainsError,
    getBrandTrackedDomainsSuccess, setBrandTrackedDomainsByBrandCode,
} from "modules/Brands/services/BrandTrackedDomains/actions";
import {
    findByBrandCodeBrandTrackedDomainsRequest,
    findByRequestBrandTrackedDomainsRequest,
} from "modules/Brands/services/BrandTrackedDomains/api";
import {brandTrackedDomainsSelector} from "./selectors";
import {ITEMS_PER_PAGE} from "constants/general";

let cachedResponse = null;

//Workers
function* handleGetBrandTrackedDomains({payload}) {
    try {
        const {
            limit = ITEMS_PER_PAGE,
            offset = 0,
            brand_code = "",
            refresh_page = false
        } = payload;

        let response;
        if (cachedResponse && !refresh_page) {
            response = cachedResponse;
        } else {
            response = yield call(findByRequestBrandTrackedDomainsRequest);
            cachedResponse = response;
        }

        let brand_tracked_domains = [...response.brand_tracked_domains];

        // -----------------------------
        // FILTERING
        // -----------------------------
        if (brand_code) {
            brand_tracked_domains = brand_tracked_domains.filter((brand_tracked_domain) =>
                brand_tracked_domain.brand_code === brand_code
            );
        }

        // -----------------------------
        // PAGINATION
        // -----------------------------
        const paginatedBrandTrackedDomains = brand_tracked_domains.slice(Number(offset), Number(offset) + Number(limit));

        //const {count, brand_tracked_domains} = yield call(findByRequestBrandTrackedDomainsRequest, payload);
        yield put(getBrandTrackedDomainsSuccess({
            brandTrackedDomains: paginatedBrandTrackedDomains,
            count: brand_tracked_domains.length
        }));
    } catch (error) {
        yield put(getBrandTrackedDomainsError());
        getErrorMessage(error);
    }
}

export function* handleGetBrandTrackedDomainsByBrandCode({ payload }) {
    try {
        const { brandTrackedDomainsByBrandCode } = yield select(brandTrackedDomainsSelector);
        const newBrandTrackedDomainsByBrandCode = { ...brandTrackedDomainsByBrandCode};
        newBrandTrackedDomainsByBrandCode[payload.code] = yield call(findByBrandCodeBrandTrackedDomainsRequest, payload.code);
        yield put(setBrandTrackedDomainsByBrandCode(newBrandTrackedDomainsByBrandCode));
    } catch (error) {
        getErrorMessage(error);
    }
}

// Watchers
export function* brandTrackedDomainsSagas() {
    yield all([
        yield takeLatest(getBrandTrackedDomains, handleGetBrandTrackedDomains),
        yield takeEvery(getBrandTrackedDomainsByBrandCode, handleGetBrandTrackedDomainsByBrandCode),
    ]);
}
